import React from 'react';
import { Edit } from '@material-ui/icons';
import { Button } from '@material-ui/core';
import classNames from 'clsx';

import { EditButtonProps } from './EditButton.interfaces';
import { useStyles } from './EditButton.styles';

export default function EditButton({
  children,
  className,
  onClick,
}: EditButtonProps) {
  const classes = useStyles();

  return (
    <Button
      onClick={onClick}
      className={classNames(classes.root, className)}
      classes={{
        endIcon: classes.icon,
      }}
      endIcon={<Edit />}
    >
      <div>{children}</div>
    </Button>
  );
}
